// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4452) return "static/chunks/4452.219952d1f1bca95f.js";
	if (chunkId === 5212) return "static/chunks/5212.121631addbaefb22.js";
	if (chunkId === 9139) return "static/chunks/9139.3db95307de74b762.js";
	if (chunkId === 3644) return "static/chunks/component-loader.219f43b0b4bd52bf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"790":"6142c5b0807f1541","3489":"f4f49966d96d6ec5","5772":"241159f2b5699dc0","8409":"993015c111cffcf2","8642":"5607c7b754434b79","8870":"43a185346560ed55"}[chunkId] + ".js";
};